import { Row, Col, Divider, Spin } from "antd";
import GenerateQuestionForm from "./components/GenerateQuestionForm";
import SelectedQuestionsPanel from "./components/SelectedQuestionsPanel";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { BASE_URL, QUIZ } from "utilFunctions/Constants/urlConstants";
import { ToastContextDispatch } from "Context/CommonContext";
const StyledCol = styled<any>(Col)`
  height: calc(100vh - 275px);
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
`;
const QuizAutoPickQuestions = () => {
  const {
    questions = [],
    isLoading,
    fetchQuizById,
    editableQuiz,
    setGeneratedQuestions,
    setActive,
    maxQuestionLimit,
    limit,
  } = useQuizContext();
  const { quizQueLim: MAXIMUM_QUESTION_COUNT } = limit || {};
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const [newSelectedQuestions, setNewSelectedQuestions] = useState([]);
  useEffect(() => {
    if (!editableQuiz.id) return;
    fetchQuizById(BASE_URL + QUIZ + "/" + editableQuiz.id);
  }, [editableQuiz]);
  const onAddHandler = () => {
    if (
      maxQuestionLimit + newSelectedQuestions.length >
      MAXIMUM_QUESTION_COUNT
    ) {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          "You have reached the maximum question limit.Please remove some questions to add more.",
      });
      return;
    }
    setGeneratedQuestions((prev: any) => {
      const existingIds = new Set(
        prev?.autoPick?.map((q: any) => q.questionId) || []
      );
      const uniqueNewQuestions = newSelectedQuestions.filter(
        (q: any) => !existingIds.has(q.questionId)
      );
      return {
        ...prev,
        autoPick: [...(prev?.autoPick || []), ...uniqueNewQuestions],
      };
    });
    setActive("3");
  };
  return (
    <>
      {isLoading && <Spin></Spin>}
      <Row gutter={24}>
        {!!questions.length && (
          <StyledCol span={24}>
            <SelectedQuestionsPanel
              newSelectedQuestions={newSelectedQuestions}
              setNewSelectedQuestions={setNewSelectedQuestions}
            />
          </StyledCol>
        )}
        <Col span={24}>
          <Divider />
          <GenerateQuestionForm
            onAddHandler={onAddHandler}
            selectedRows={newSelectedQuestions}
          />
        </Col>
      </Row>
    </>
  );
};

export default QuizAutoPickQuestions;
